import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function PositionsPage() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("positions");
  const [selectedTrade, setSelectedTrade] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [balance, setBalance] = useState(0);
  const [name, setName] = useState('');
  const [mob, setMob] = useState('');
  const [uid, setUid] = useState('');
  const [bsid, setBsid] = useState('');
  const [showoff, setShowoff] = useState(false);
  const [holding, setHolding] = useState(false);
  const [edit_type, setEdit_type] = useState('');
  const [target, setTarget] = useState('');
  const [stoploss, setStoploss] = useState('');
  const [openOrders, setOpenOrders] = useState([]);
  const [trd_status, setTrd_status] = useState('');
  const [closedOrders, setClosedOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [refreshing, setRefreshing] = useState(false);

  const onRefresh = async () => {
    setRefreshing(true);
    await fetchData();
    setRefreshing(false);
  };

  const fetchData = async () => {
    try {
      const uid = localStorage.getItem("userid");
      const name = localStorage.getItem("name");
      const mobile = localStorage.getItem("mobile");
      
      setName(name || 'User');
      setUid(uid || '');
      setMob(mobile || '');

      if (uid) {
        const response = await fetch('https://singlewindowsecurities.com/Rest3/wallet_api/' + uid);
        const responseJson = await response.json();
        setBalance(responseJson.wallet || 0);
        await fetchOpenOrders(uid);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();
    
    if (activeTab === 'positions') {
      const interval = setInterval(async () => {
        const uid = localStorage.getItem("userid");
        if (uid) fetchOpenOrders(uid);
      }, 2000);

      return () => clearInterval(interval);
    }
  }, [activeTab]);

  const fetchOpenOrders = async (uid) => {
    try {
      const response = await fetch('https://singlewindowsecurities.com/Rest3/my_trades_api/' + uid);
      const responseJson = await response.json();
      const formattedData = Array.isArray(responseJson) ? responseJson.map(trade => ({
        id: trade.bsid,
        tstatus: trade.status,
        del_req: trade.del_req,
        holding: trade.holding,
        symbol: trade.metal || 'N/A',
        name: trade.metal || 'Trade',
        quantity: trade.lotsize || 0,
        target: trade.target,
        stoploss: trade.stoploss,
        avgPrice: trade.setlimit || '0.00',
        ltp: trade.last_live || '0.00',
        pnl: trade.pro_loss >= 0 ? `+${trade.pro_loss}` : `${trade.pro_loss}`,
        pnlPercent: trade.pro_loss >= 0 ? `+${Math.abs(trade.pro_loss)}%` : `-${Math.abs(trade.pro_loss)}%`,
        type: trade.type || 'BUY',
        status: trade.holding === 'On' ? 'HOLD' : 'Active',
        time: trade.trd_in,
        date: trade.bsday,
        exchange: 'MCX',
        color: trade.type === "BUY" ? (trade.pro_loss >= 0 ? "#10B981" : "#EF4444") : 
               (trade.pro_loss >= 0 ? "#10B981" : "#EF4444"),
        rawData: trade
      })) : [];
      setOpenOrders(formattedData);
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  const fetchClosedOrders = async () => {
    try {
      const uid = localStorage.getItem("userid");
      if (!uid) return;
      const response = await fetch('https://singlewindowsecurities.com/Rest3/exit_trades_api/' + uid);
      const responseJson = await response.json();
      const formattedData = Array.isArray(responseJson) ? responseJson.map(trade => ({
        id: trade.bsid,
        tstatus: trade.status,
        del_req: trade.del_req,
        symbol: trade.metal || 'N/A',
        name: trade.metal || 'Trade',
        quantity: trade.lotsize || 0,
        target: trade.target,
        stoploss: trade.stoploss,
        avgPrice: trade.setlimit || '0.00',
        ltp: trade.last_live || '0.00',
        pnl: trade.pro_loss >= 0 ? `+${trade.pro_loss}` : `${trade.pro_loss}`,
        pnlPercent: trade.pro_loss >= 0 ? `+${Math.abs(trade.pro_loss)}%` : `-${Math.abs(trade.pro_loss)}%`,
        type: trade.type || 'BUY',
        status: trade.holding === 'On' ? 'HOLD' : 'Active',
        time: trade.trd_out,
        date: trade.bsdate,
        exchange: 'MCX',
        color: trade.type === "BUY" ? (trade.pro_loss >= 0 ? "#10B981" : "#EF4444") : 
               (trade.pro_loss >= 0 ? "#10B981" : "#EF4444"),
        rawData: trade
      })) : [];
      setClosedOrders(formattedData);
    } catch (error) {
      console.error(error);
    }
  };

  const handleTabPress = (tabName) => {
    setActiveTab(tabName);
    if (tabName === 'orders') {
      fetchClosedOrders();
    } else {
      const uid = localStorage.getItem("userid");
      if (uid) fetchOpenOrders(uid);
    }
  };

  const handleTradeSelect = (trade) => {
    setSelectedTrade(trade);
    setModalVisible(true);
  };

  const editTrade = async (trade) => {
    setEditModalVisible(true);
    setBsid(trade.rawData.bsid);
    setTrd_status(trade.rawData.status);
    setEdit_type(trade.rawData.type);
    setTarget(trade.rawData.target?.toString() || '');
    setStoploss(trade.rawData.stoploss?.toString() || '');
    setShowoff(trade.rawData.sq_off === 'On');
    setHolding(trade.rawData.holding === 'On');
  };

  const tradeEditSubmit = () => {
    if (!bsid) return;
    
    if (edit_type === "BUY" && target === '') setTarget('100000');
    if (edit_type === "BUY" && stoploss === '') setStoploss('0');
    if (edit_type === "SELL" && target === '') setTarget('0');
    if (edit_type === "SELL" && stoploss === '') setStoploss('100000');

    fetch('https://singlewindowsecurities.com/Rest3/update_trade_api/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        target: target,
        stoploss: stoploss,
        bsid: bsid,
      }),
    })
    .then(response => response.json())
    .then(responseJson => {
      alert(responseJson.msg);
      if (responseJson.status === 0) {
        setEditModalVisible(false);
        const uid = localStorage.getItem("userid");
        if (uid) fetchOpenOrders(uid);
      }
    })
    .catch(error => {
      console.error(error);
      alert("Failed to update trade");
    });
  };

  const squareOff = () => {
    if (!bsid) return;
    
    setLoading(true);
    fetch(`https://singlewindowsecurities.com/Rest3/square_off_api/${bsid}`)
      .then(response => response.json())
      .then(responseJson => {
        setLoading(false);
        alert(responseJson.status === 0 ? "Success" : "Error", responseJson.msg);
        if (responseJson.status === 0) {
          setEditModalVisible(false);
          const uid = localStorage.getItem("userid");
          if (uid) fetchOpenOrders(uid);
        }
      })
      .catch(error => {
        console.error(error);
        setLoading(false);
        alert("Failed to square off");
      });
  };

  const setDelivery = (id) => {
    const urls = 'https://singlewindowsecurities.com/Rest3/set_delivery_api/' + id;
    fetch(urls)
      .then(response => response.json())
      .then(responseJson => {
        alert("Delivery Requested");
        const uid = localStorage.getItem("userid");
        if (uid) fetchOpenOrders(uid);
      })
      .catch(error => {
        console.log(error);
        alert("Failed to request delivery");
      });
  };

  const intraSet = (id) => {
    const urls = 'https://singlewindowsecurities.com/Rest3/set_intraday_api/' + id;
    fetch(urls)
      .then(response => response.json())
      .then(responseJson => {
        alert("Converted to intraday");
        const uid = localStorage.getItem("userid");
        if (uid) fetchOpenOrders(uid);
      })
      .catch(error => {
        console.log(error);
        alert("Failed to convert to intraday");
      });
  };

  const calculateTotalPL = () => {
    if (activeTab !== 'positions') return '0.00';
    return openOrders.reduce((total, item) => {
      const pnl = parseFloat(item.rawData?.pro_loss || 0);
      return total + pnl;
    }, 0).toFixed(2);
  };

  const currentData = activeTab === "positions" ? openOrders : closedOrders;
  const totalPL = calculateTotalPL();
  const isProfit = parseFloat(totalPL) >= 0;

  const formatIndianCurrency = (num) => {
    if (!num) return '0.00';
    return parseFloat(num).toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  };

  if (loading && currentData.length === 0) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh', background: '#0a0a0a' }}>
        <div className="text-center">
          <div className="spinner-border" style={{ color: '#D4AF37' }} role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="mt-3" style={{ color: '#D4AF37' }}>Loading positions...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid p-0" style={{ 
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 50%, #0d0d0d 100%)'
    }}>
      {/* Stats Section */}
      <div className="container mt-3">
        <div style={{
          background: 'linear-gradient(145deg, rgba(212, 175, 55, 0.15), rgba(184, 150, 12, 0.05))',
          borderRadius: '24px',
          padding: '20px',
          border: '1px solid rgba(212, 175, 55, 0.2)',
          marginBottom: '16px'
        }}>
          <div className="row">
            <div className="col-6">
              <small style={{ color: '#D4AF37', letterSpacing: '1px', fontSize: '10px' }}>BALANCE</small>
              <h4 className="fw-bold mb-2" style={{ color: '#D4AF37' }}>₹{formatIndianCurrency(balance)}</h4>
              <small style={{ color: '#888', fontSize: '10px' }}>LEVERAGE</small>
              <div style={{ color: '#D4AF37', fontWeight: 'bold' }}>₹{formatIndianCurrency(balance * 5)}</div>
            </div>
            <div className="col-6 text-end">
              <small style={{ color: '#D4AF37', letterSpacing: '1px', fontSize: '10px' }}>LIVE P&L</small>
              <h3 className={`fw-bold mb-0 ${isProfit ? 'text-success' : 'text-danger'}`}
                  style={{ color: isProfit ? '#00C853' : '#FF5252' }}>
                {isProfit ? '+' : ''}{totalPL}
              </h3>
            </div>
          </div>
        </div>
      </div>

      {/* Tabs */}
      <div className="container mt-2">
        <div className="d-flex gap-2 p-1" style={{
          background: 'rgba(20, 20, 20, 0.8)',
          borderRadius: '30px',
          border: '1px solid rgba(212, 175, 55, 0.15)'
        }}>
          <button
            className={`btn flex-fill py-2 ${activeTab === 'positions' ? 'btn-golden' : ''}`}
            onClick={() => handleTabPress('positions')}
            style={{
              background: activeTab === 'positions' ? 'linear-gradient(145deg, #D4AF37, #B8960C)' : 'transparent',
              border: 'none',
              borderRadius: '30px',
              color: activeTab === 'positions' ? '#000' : '#888',
              fontWeight: 'bold',
              transition: 'all 0.3s ease'
            }}
          >
            Open Positions
          </button>
          <button
            className={`btn flex-fill py-2 ${activeTab === 'orders' ? 'btn-golden' : ''}`}
            onClick={() => handleTabPress('orders')}
            style={{
              background: activeTab === 'orders' ? 'linear-gradient(145deg, #D4AF37, #B8960C)' : 'transparent',
              border: 'none',
              borderRadius: '30px',
              color: activeTab === 'orders' ? '#000' : '#888',
              fontWeight: 'bold',
              transition: 'all 0.3s ease'
            }}
          >
            Closed Orders
          </button>
        </div>
      </div>

      {/* Orders Count */}
      <div className="container mt-3">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <span style={{
            background: 'rgba(212, 175, 55, 0.1)',
            color: '#D4AF37',
            padding: '4px 10px',
            borderRadius: '12px',
            fontSize: '11px',
            fontWeight: 'bold'
          }}>
            <i className="fa fa-list me-1"></i>
            {currentData.length} {activeTab === 'positions' ? 'active' : 'closed'} trades
          </span>
          
          {activeTab === 'positions' && openOrders.length > 0 && (
            <span style={{
              background: 'rgba(0, 200, 83, 0.15)',
              color: '#00C853',
              padding: '4px 10px',
              borderRadius: '12px',
              fontSize: '11px',
              fontWeight: 'bold'
            }}>
              <i className="fa fa-circle-fill me-1" style={{ fontSize: '8px' }}></i>
              Live Updates
            </span>
          )}
        </div>

        {/* Trade Cards */}
        {currentData.length > 0 ? (
          <div className="row g-3 pb-4">
            {currentData.map((trade, index) => (
              <div key={trade.id} className="col-12">
                <div 
                  style={{
                    background: 'rgba(20, 20, 20, 0.95)',
                    borderRadius: '20px',
                    border: '1px solid rgba(212, 175, 55, 0.15)',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    overflow: 'hidden'
                  }}
                  
                >
                  <div className="p-3">
                    <div className="d-flex justify-content-between align-items-start mb-2" onClick={() => editTrade(trade)}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.borderColor = '#D4AF37';
                    e.currentTarget.style.transform = 'translateX(4px)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.borderColor = 'rgba(212, 175, 55, 0.15)';
                    e.currentTarget.style.transform = 'translateX(0)';
                  }}>
                      <div className="d-flex align-items-center">
                        <div style={{
                          width: '40px',
                          height: '40px',
                          background: trade.type === "BUY" ? 'rgba(0, 200, 83, 0.15)' : 'rgba(255, 82, 82, 0.15)',
                          borderRadius: '12px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          marginRight: '12px'
                        }}>
                          <i className={`fa fa-arrow-${trade.type === "BUY" ? 'up' : 'down'}`} 
                             style={{ color: trade.type === "BUY" ? '#00C853' : '#FF5252', fontSize: '18px' }}></i>
                        </div>
                        <div>
                          <h6 className="fw-bold mb-1" style={{ color: '#D4AF37' }}>{trade.symbol}</h6>
                          <div className="d-flex align-items-center gap-2">
                            <span style={{
                              background: trade.type === "BUY" ? 'rgba(0, 200, 83, 0.15)' : 'rgba(255, 82, 82, 0.15)',
                              color: trade.type === "BUY" ? '#00C853' : '#FF5252',
                              padding: '2px 8px',
                              borderRadius: '12px',
                              fontSize: '10px',
                              fontWeight: 'bold'
                            }}>
                              {trade.type.toUpperCase()}
                            </span>
                            <small style={{ color: '#888' }}>{trade.quantity} LOT</small>
                          </div>
                        </div>
                      </div>
                      
                      <div className="text-end">
                        <h5 className={`fw-bold mb-0 ${parseFloat(trade.rawData?.pro_loss || 0) >= 0 ? 'text-success' : 'text-danger'}`}
                            style={{ color: parseFloat(trade.rawData?.pro_loss || 0) >= 0 ? '#00C853' : '#FF5252' }}>
                          {trade.pnl}
                        </h5>
                        <small style={{ color: '#888' }}>{trade.date}</small>
                      </div>
                    </div>

                    {/* Price Comparison */}
                    <div style={{
                      background: 'rgba(26, 26, 26, 0.6)',
                      borderRadius: '16px',
                      padding: '12px',
                      marginTop: '8px'
                    }}>
                      <div className="row text-center">
                        <div className="col-4">
                          <small style={{ color: '#888', fontSize: '10px' }}>LIMIT</small>
                          <div className="fw-bold" style={{ color: '#D4AF37', fontSize: '13px' }}>{trade.avgPrice}</div>
                        </div>
                        <div className="col-4">
                          <i className={`fa fa-arrow-${trade.type === "BUY" ? 'right' : 'left'}`} 
                             style={{ color: trade.type === "BUY" ? '#00C853' : '#FF5252' }}></i>
                        </div>
                        <div className="col-4">
                          <small style={{ color: '#888', fontSize: '10px' }}>LTP</small>
                          <div className={`fw-bold ${trade.type === "BUY" ? 'text-success' : 'text-danger'}`}
                               style={{ color: trade.type === "BUY" ? '#00C853' : '#FF5252', fontSize: '13px' }}>
                            {trade.ltp}
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Tags */}
                      {trade.tstatus !== 'EXIT' && (
  <div className="d-flex justify-content-between align-items-center">
    <div className="d-flex align-items-center">
      {trade.target !== '' && (
        <div
          className="me-2 px-2 py-1 rounded"
          style={{
            backgroundColor: 'rgba(59, 130, 246, 0.15)',
            border: '0.5px solid rgba(59, 130, 246, 0.3)',
          }}
        >
          <span
            style={{
              fontSize: '10px',
              fontWeight: 600,
              color: '#60A5FA',
            }}
          >
            TGT: {trade.target}
          </span>
        </div>
      )}

      {trade.stoploss !== '' && (
        <div
          className="px-2 py-1 rounded"
          style={{
            backgroundColor: 'rgba(239, 68, 68, 0.15)',
            border: '0.5px solid rgba(239, 68, 68, 0.3)',
          }}
        >
          <span
            style={{
              fontSize: '10px',
              fontWeight: 600,
              color: '#F87171',
            }}
          >
            STL: {trade.stoploss}
          </span>
        </div>
      )}
    </div>

    <div className="d-flex align-items-center">
      {trade.holding === 'On' && (
        <div
          className="px-2 py-1 rounded"
          style={{
            backgroundColor: 'rgba(245, 158, 11, 0.15)',
            border: '0.5px solid rgba(245, 158, 11, 0.3)',
          }}
        >
          <span
            style={{
              fontSize: '10px',
              fontWeight: 700,
              color: '#F59E0B',
            }}
          >
            HOLD
          </span>
        </div>
      )}

      {trade.holding !== 'On' && trade.tstatus !== 'EXIT' && (
        <button
          onClick={() => setDelivery(trade.id)}
          className="btn btn-sm"
          style={{
            backgroundColor: 'rgba(212, 175, 55, 0.15)',
            border: '0.5px solid rgba(212, 175, 55, 0.4)',
            color: '#D4AF37',
            fontSize: '10px',
            fontWeight: 600,
            padding: '3px 8px',
          }}
        >
          Delivery
        </button>
      )}

      {trade.del_req !== '' && (
        <span
          className="ms-2"
          style={{
            fontSize: '10px',
            color: '#F59E0B',
            fontWeight: 500,
          }}
        >
          Requested
        </span>
      )}
    </div>
  </div>
)}
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div style={{
            background: 'rgba(20, 20, 20, 0.95)',
            borderRadius: '24px',
            border: '1px solid rgba(212, 175, 55, 0.15)',
            textAlign: 'center',
            padding: '48px 24px'
          }}>
            <div style={{
              width: '70px',
              height: '70px',
              background: 'rgba(212, 175, 55, 0.1)',
              borderRadius: '35px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 16px'
            }}>
              <i className="fa fa-file-text" style={{ color: '#D4AF37', fontSize: '32px' }}></i>
            </div>
            <h5 className="fw-bold mb-2" style={{ color: '#fff' }}>No {activeTab === 'positions' ? 'active positions' : 'closed orders'}</h5>
            <p style={{ color: '#888' }}>
              {activeTab === 'positions' 
                ? 'Start trading to see your open positions here'
                : 'Closed trades will appear here'}
            </p>
          </div>
        )}
      </div>

      {/* Edit Modal */}
      {editModalVisible && (
        <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.8)' }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content" style={{
              background: '#1a1a1a',
              borderRadius: '24px',
              border: '1px solid rgba(212, 175, 55, 0.2)'
            }}>
              <div className="modal-header" style={{ borderBottom: '1px solid rgba(212, 175, 55, 0.1)' }}>
                <h5 className="modal-title fw-bold" style={{ color: '#D4AF37' }}>Edit Trade</h5>
                <button 
                  type="button" 
                  className="btn-close btn-close-white" 
                  onClick={() => setEditModalVisible(false)}
                ></button>
              </div>
              
              <div className="modal-body p-4">
                <div className="mb-3">
                  <label className="form-label small" style={{ color: '#D4AF37', letterSpacing: '1px' }}>TARGET PRICE</label>
                  <input
                    type="number"
                    className="form-control"
                    style={{
                      background: '#1a1a1a',
                      border: '1px solid rgba(212, 175, 55, 0.3)',
                      borderRadius: '12px',
                      color: '#fff'
                    }}
                    value={target}
                    onChange={(e) => setTarget(e.target.value)}
                    placeholder="Enter target price"
                  />
                </div>

                <div className="mb-4">
                  <label className="form-label small" style={{ color: '#D4AF37', letterSpacing: '1px' }}>STOP LOSS</label>
                  <input
                    type="number"
                    className="form-control"
                    style={{
                      background: '#1a1a1a',
                      border: '1px solid rgba(212, 175, 55, 0.3)',
                      borderRadius: '12px',
                      color: '#fff'
                    }}
                    value={stoploss}
                    onChange={(e) => setStoploss(e.target.value)}
                    placeholder="Enter stop loss"
                  />
                </div>

                {trd_status === 'start' && (
                  <div className="d-flex gap-3">
                    <div className="flex-grow-1">
                      <button 
                        className="btn w-100 py-2"
                        onClick={squareOff}
                        style={{
                          background: 'rgba(212, 175, 55, 0.1)',
                          border: '1px solid rgba(212, 175, 55, 0.3)',
                          borderRadius: '12px',
                          color: '#D4AF37',
                          fontWeight: 'bold'
                        }}
                      >
                        SQR OFF
                      </button>
                    </div>
                    
                    {holding !== 'On' && (
                      <div className="flex-grow-1">
                        <button 
                          className="btn w-100 py-2"
                          onClick={tradeEditSubmit}
                          style={{
                            background: 'linear-gradient(145deg, #D4AF37, #B8960C)',
                            border: 'none',
                            borderRadius: '12px',
                            color: '#000',
                            fontWeight: 'bold'
                          }}
                        >
                          UPDATE
                        </button>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      <style>
        {`
          .btn-golden {
            background: linear-gradient(145deg, #D4AF37, #B8960C);
            transition: all 0.3s ease;
          }
          .btn-golden:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 15px rgba(212, 175, 55, 0.3);
          }
          input:focus {
            box-shadow: 0 0 0 2px rgba(212, 175, 55, 0.3) !important;
            outline: none;
            border-color: #D4AF37 !important;
          }
        `}
      </style>
    </div>
  );
}